





























































import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import RespondecoToolbarItem from '@/shared/components/toolbar/respondeco-toolbar-item.vue'
import MiniatureView from '@/shared/components/miniature-view/miniature-view.vue'
import MiniatureItem from '@/shared/components/miniature-view/miniature-item.vue'
import AddOrganisationDialog from '@/business/administration/components/add-organisation-dialog.vue'
import { Inject, Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'
import { Injector } from '@/config/dependency-injection'
import { DialogService } from '@/shared/dialog/dialog-service'
import { updateOrAppend, withoutEntry } from '@/shared/utils/list'
import { imageUrl } from '@/shared/utils/images'
import { OfferForm } from '@/business/offers/models/offer-form'
import { OfferPartner } from '@/business/offers/models/offer-partner'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { BvTableFieldArray } from 'bootstrap-vue'
import { i18n } from '@/config/i18n'
import { OfferResponse } from '@/api/generated'
import { parseISO } from 'date-fns'
import { AuthenticationService } from '@/authentication/authentication-service'

@Component({
  components: {
    AddOrganisationDialog,
    MiniatureItem,
    MiniatureView,
    RespondecoToolbarItem,
    RespondecoToolbar,
  },
})
export default class OfferSettingsPartners extends Vue {
  @Inject()
  public readonly form!: FormGroup<OfferForm>

  @Prop({
    default: null,
    type: Object,
  })
  public readonly offer!: OfferResponse | null

  get partners(): OrganisationLite[] {
    return this.form.field('partners').$model.map(partner => partner.organisation) ?? []
  }

  get project(): string | undefined {
    return (
      this.offer?.project ?? this.authenticationService.authenticatedUser()?.organisation.project
    )
  }

  public fields: BvTableFieldArray = []
  public imageUrl = imageUrl

  private authenticationService = Injector.get(AuthenticationService)
  private dialogService = Injector.get(DialogService)

  get controlValue(): OfferPartner[] {
    return this.form.field('partners').$model
  }

  set controlValue(partners: OfferPartner[]) {
    this.form.field('partners').$model = partners
  }

  get length() {
    return this.controlValue?.length ?? 0
  }

  mounted() {
    if (this.project != null) {
      this.fields = [
        {
          key: 'organisation',
          label: i18n.t(`${this.project}.offer.settings.partners.table.organisation`) as string,
          sortable: true,
          tdClass: 'align-middle',
        },
        { key: 'action', tdClass: 'align-middle' },
      ]
    } else {
      this.fields = [
        {
          key: 'organisation',
          label: i18n.t('offer.settings.partners.table.organisation') as string,
          sortable: true,
          sortByFormatted: (value: OrganisationLite) => {
            return value.name
          },
          tdClass: 'align-middle',
        },

        {
          key: 'date',
          label: i18n.t('offer.settings.partners.table.date') as string,
          sortable: true,
          sortByFormatted: value => parseISO(value).getTime(),
          tdClass: 'align-middle',
        },

        { key: 'action', tdClass: 'align-middle' },
      ]
    }
  }

  public addPartner(organisation: OrganisationLite) {
    this.controlValue = updateOrAppend(
      this.controlValue,
      {
        date: new Date().toISOString().substring(0, 10),
        organisation,
      },
      (a, b) => a.organisation.id === b.organisation.id
    )
  }

  public chooseOrganisation(): void {
    this.dialogService.open('ADD_ORGANISATION_DIALOG')
  }

  public markAsDirty(): void {
    this.form.field('partners').$touch()
  }

  public removePartner(partner: OfferPartner): void {
    this.controlValue = withoutEntry(
      this.controlValue,
      partner,
      (a, b) => a.organisation.id === b.organisation?.id
    )
  }
}
